const isAdaptiveCard = (jsonObject: unknown): boolean => {
    // Check for required properties of an Adaptive Card
    if (!jsonObject || typeof jsonObject !== 'object') {
        return false;
    }

    const candidate = jsonObject as Record<string, unknown>;
    return (
        candidate.type === 'AdaptiveCard' &&
        typeof candidate.version === 'string' &&
        Array.isArray(candidate.body)
    );
};

export default isAdaptiveCard;
